import { render, staticRenderFns } from "./user-widget.vue?vue&type=template&id=047d100c"
import script from "./user-widget.ts?vue&type=script&lang=js&external"
export * from "./user-widget.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports